import standardAPI from '@/api/standard_items';

const responseUrl = '/blog/authors';

const state = {
  authors: [],
  authors_MetaData: {},
  authors_status: '',
  authors_page: 1,
  authors_perPage: 10,
};

const getters = {
  get_authors: (state) => {
    return state.authors;
  },
  get_authors_status: (state) => {
    return state.authors_status;
  },
};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_authors ({ commit }, getOptions) {
    commit('DATA_AUTHORS_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            commit('DATA_AUTHORS_UPDATE_SUCCESS', response);
            commit('DATA_AUTHORS_READY');
            resolve(response);
          } else if (response.status === 404) {
            commit('DATA_AUTHORS_READY');
            reject(response);
          } else {
            commit('DATA_AUTHORS_ERROR');
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  fetch_authors_silent ({ commit }, getOptions) {
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            resolve(response);
          } else if (response.status === 404) {
            reject(response);
          } else {
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  add_author ({ commit, dispatch }, itemData) {
    commit('DATA_AUTHORS_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.add_item(preparedData, (response) => {
        if (response.status === 'created') {
          commit('DATA_AUTHORS_REQUEST');
          resolve(response);
        } else {
          commit('DATA_AUTHORS_READY');
          reject(response);
        }
      });
    });
  },
  edit_author ({ commit, dispatch }, itemData) {
    commit('DATA_AUTHORS_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl + '/',
    };
    return new Promise((resolve, reject) => {
      standardAPI.edit_item(preparedData, (response) => {
        if (response.status === 'updated') {
          commit('DATA_AUTHORS_REQUEST');
          resolve(response);
        } else {
          commit('DATA_AUTHORS_READY');
          reject(response);
        }
      });
    });
  },
  remove_authors ({ commit, dispatch }, itemData) {
    commit('DATA_AUTHORS_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.remove_items(preparedData, (response) => {
        if (response.status === 'deleted') {
          commit('DATA_AUTHORS_REQUEST');
          resolve(response);
        } else {
          commit('DATA_AUTHORS_READY');
          reject(response);
        }
      });
    });
  },
  reorder_author ({ commit, dispatch }, orderData) {
    const preparedData = {
      orderData,
      url: responseUrl + '/reorder',
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.authors_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.authors_perPage = max;
  },
  DATA_AUTHORS_READY: (state) => {
    state.authors_status = 'ready';
  },
  DATA_AUTHORS_REQUEST: (state) => {
    state.authors_status = 'loading';
  },
  DATA_AUTHORS_UPDATE_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.authors_MetaData.meta = response.meta;
      state.authors_MetaData.links = response.links;
    }
    state.authors = response.data;
    state.authors_status = 'success';
  },
  DATA_AUTHORS_ERROR: (state) => {
    state.authors_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
